const validator = require('ui-validator');

const v = validator.validators;
const validations = {
  loanType: {
    required: v.required({ key: 'application type' }),
    whitelist: v.whitelist({ whitelist: ['individual', 'joint'] }),
  },
};

export default validations;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pages/LoanType/LoanType.scss');